module.exports = __webpack_public_path__ + "img/kv-sp.65f9771.webp";